import { AxiosInstance } from 'axios';
import { RequestEndpoint, DeclineRequestRequest } from './RequestServices.types';

export class RequestServices implements RequestEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getRequests(jobGuid: string) {
    return this.instance.get(`/loadboards/requests/job/${jobGuid}`);
  }

  acceptRequest(requestGuid: string) {
    return this.instance.put(`/loadboards/requests/${requestGuid}/accept`);
  }

  declineRequest(request: DeclineRequestRequest) {
    return this.instance.put(
      `/loadboards/requests/${request.routeParams.requestGuid}/decline`,
      request.body,
    );
  }
}
